import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ApiService } from "app/services/api";
import * as lodash from "lodash";
import { AngularFireDatabase } from "angularfire2/database";

@Component({
  selector: "app-website-enquiries",
  templateUrl: "./website-enquiries.component.html",
  styleUrls: ["./website-enquiries.component.scss"],
})
export class WebsiteEnquiriesComponent implements OnInit {
  public enquiries: Array<any> = [];
  constructor(private firebaseDatabase: AngularFireDatabase) {}
  ngOnInit() {
    this.firebaseDatabase.object("/website-contacts").subscribe((data) => {
      if (data) {
        Object.keys(data).map((x) => {
          let date = new Date(data[x].createdAt);
          let formatedDate =
            date.getDate() +
            "-" +
            (date.getMonth() + 1) +
            "-" +
            date.getFullYear();
          data[x]["formatedCreatedAt"] = formatedDate;
          this.enquiries.push(data[x]);
        });
      }
      console.log(this.enquiries);
    });
  }
}
